"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _Message = require('shared/components/Message'); var _Message2 = _interopRequireDefault(_Message);








var _message = require('shared/enum/message');




var _TextMessage = require('./TextMessage'); var _TextMessage2 = _interopRequireDefault(_TextMessage);
var _DateMessage = require('./DateMessage'); var _DateMessage2 = _interopRequireDefault(_DateMessage);
var _MetaMessageRow = require('./MetaMessageRow'); var _MetaMessageRow2 = _interopRequireDefault(_MetaMessageRow);
var _AutoReplyMessage = require('./AutoReplyMessage'); var _AutoReplyMessage2 = _interopRequireDefault(_AutoReplyMessage);
var _FileMessage = require('./FileMessage'); var _FileMessage2 = _interopRequireDefault(_FileMessage);
var _ImageGroupMessage = require('./ImageGroupMessage'); var _ImageGroupMessage2 = _interopRequireDefault(_ImageGroupMessage);
var _forms = require('shared/services/forms');
var _FormTextMessage = require('web/components/Forms/FormTextMessage'); var _FormTextMessage2 = _interopRequireDefault(_FormTextMessage);



























































const noop = () => ''
// Shared fallback so a row without subscribers keeps one identity across renders.
const EMPTY_SUBSCRIBERS = Object.freeze({})

// Row-independent render props, hoisted so every render passes the same identity.
// SAFETY: row keys are MessageKeys and date rows always have text
// (processMessages builds them); SharedMessage types both loosely.
const renderMetaMessage = ({ text, messageKey, sentAt }) => (
  _react2.default.createElement(_MetaMessageRow2.default, { text: text, messageKey: messageKey , sentAt: sentAt, __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}} )
)

// SAFETY: as above.
const renderAutoReplyMessage = ({ text, messageKey, sentAt, highlighted }) => (
  _react2.default.createElement(_AutoReplyMessage2.default, { text: text, messageKey: messageKey , sentAt: sentAt, highlighted: highlighted, __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}} )
)

// SAFETY: as above.
const renderDateMarker = ({ text, messageKey }) => (
  _react2.default.createElement(_DateMessage2.default, { text: text , messageKey: messageKey , __self: this, __source: {fileName: _jsxFileName, lineNumber: 101}} )
)

/* Was a PureComponent: memo keeps the same shallow props comparison, which
 * the row-identity cache (TM-556) relies on to skip unchanged rows. */
function Message (props) {
  const {
    Avatar,
    ConversationKey,
    DisplayName,
    FileName,
    FileInfo,
    FileReference,
    MessageKey,
    MessageText,
    Mentions,
    MessageType,
    PatientKey,
    APIKeyKey,
    SenderType,
    SentAt,
    Sequence,
    TeamKey,
    UserKey,
    SeenBy,
    SameSenderAsNextMessage,
    SameSenderAsPreviousMessage,
    Uploading,
    SendFailed,
    currentUserKey,
    highlighted,
    onDelete,
    onCopyMessageLink,
    Deleted,
    deliveryStatus,
    ReplyToMessageKey,
    ReplyPreview,
    onJumpToMessage,
    onReply,
    onRetrySendMessage,
    onRetrySendFile,
    onAbortSendFile,
    isLastMessage,
    isEntering,
    onAddReaction,
    onRemoveReaction,
    Reactions: reactions,
    SMSDeliveryOutcomes: smsDeliveryOutcomes,
    readOnly,
    recallOnlyAwaitingConsent,
    Caption,
    ImageGroup,
    InImageGroup,
    Translation: translation,
    Delivered: delivered,
    Deliveries: deliveries,
    SpamBand: spamBand,
    showTranslations,
  } = props

  // The class's onReply was an instance field: one identity for the row's
  // lifetime, reading the props current when it is called. The ref is synced
  // after each commit, as this.props was.
  const latestProps = _react.useRef.call(void 0, props)
  _react.useLayoutEffect.call(void 0, () => {
    latestProps.current = props
  })
  const handleReply = _react.useCallback.call(void 0, () => {
    // Only passed down while onReply is set (see below).
    latestProps.current.onReply(latestProps.current)
  }, [])
  const rowOnReply = onReply ? handleReply : undefined
  // Replying to the caption quotes the caption's own message.
  const handleReplyCaption = _react.useCallback.call(void 0, () => {
    const { onReply: reply, Caption: caption } = latestProps.current
    // Only passed down while both are set (see below).
    reply(caption)
  }, [])
  const captionOnReply = onReply && Caption ? handleReplyCaption : undefined

  // The render props are called during SharedMessage's render, so they read
  // this render's props (deps), not the ref.
  //
  // Each row gets every field SharedMessage hands it (the same set the class
  // listed one by one) plus this adapter's own props, which override
  // SharedMessage's onReply/onJumpToMessage with the same values.
  const renderFileMessage = _react.useCallback.call(void 0, (fileProps) => {
    // SAFETY: SharedMessage types its render props loosely (shared/ cannot
    // use the web row types) and rows may lack fields (the specs' minimal
    // rows); the JS passed these values through unchanged, as this does.
    const rowProps = {
      ...fileProps,
      onCopyMessageLink,
      onRetry: onRetrySendFile,
      onAbort: onAbortSendFile,
      isLastMessage,
      isEntering,
      reactions,
      onAddReaction,
      onRemoveReaction,
      onReply: rowOnReply,
      onJumpToMessage,
      readOnly,
      caption: Caption,
      onReplyCaption: captionOnReply,
      smsDeliveryOutcomes,
      recallOnlyAwaitingConsent,
    } 
    if (ImageGroup) {
      return _react2.default.createElement(_ImageGroupMessage2.default, { ...rowProps, group: ImageGroup, onReply: onReply, __self: this, __source: {fileName: _jsxFileName, lineNumber: 210}} )
    }
    return _react2.default.createElement(_FileMessage2.default, { ...rowProps, __self: this, __source: {fileName: _jsxFileName, lineNumber: 212}} )
  }, [
    ImageGroup, onReply,
    onCopyMessageLink, onRetrySendFile, onAbortSendFile, isLastMessage, isEntering,
    reactions, onAddReaction, onRemoveReaction, rowOnReply, onJumpToMessage, readOnly,
    Caption, captionOnReply,
    smsDeliveryOutcomes, recallOnlyAwaitingConsent,
  ])

  const renderTextMessage = _react.useCallback.call(void 0, (textProps) => {
    // SAFETY: as for file rows above.
    const rowProps = {
      ...textProps,
      onCopyMessageLink,
      onRetry: onRetrySendMessage,
      isLastMessage,
      isEntering,
      reactions,
      onAddReaction,
      onRemoveReaction,
      onReply: rowOnReply,
      onJumpToMessage,
      readOnly,
      smsDeliveryOutcomes,
      recallOnlyAwaitingConsent,
      translation,
      delivered,
      deliveries,
      spamBand,
      showTranslations,
    } 
    // A sent form: its card, in a patient chat of an org with Forms.
    const formCode = _forms.formCodesInText.call(void 0, rowProps.text)[0]
    if (formCode) return _react2.default.createElement(_FormTextMessage2.default, { ...rowProps, code: formCode, __self: this, __source: {fileName: _jsxFileName, lineNumber: 245}} )
    return _react2.default.createElement(_TextMessage2.default, { ...rowProps, __self: this, __source: {fileName: _jsxFileName, lineNumber: 246}} )
  }, [
    onCopyMessageLink, onRetrySendMessage, isLastMessage, isEntering, reactions,
    onAddReaction, onRemoveReaction, rowOnReply, onJumpToMessage, readOnly,
    smsDeliveryOutcomes, recallOnlyAwaitingConsent,
    translation, delivered, deliveries, spamBand, showTranslations,
  ])

  const subscribers = props.subscribers || EMPTY_SUBSCRIBERS

  // The newest image of the group draws the grid; this row keeps only its
  // anchor, so jumping to it still scrolls to the grid.
  if (InImageGroup) return _react2.default.createElement('div', { id: MessageKey, className: "image-group--anchor", __self: this, __source: {fileName: _jsxFileName, lineNumber: 258}} )

  return (
    _react2.default.createElement(_Message2.default, {
      highlighted: highlighted,
      Avatar: Avatar,
      ConversationKey: ConversationKey,
      DisplayName: DisplayName,
      FileName: FileName,
      FileInfo: FileInfo,
      FileReference: FileReference,
      MessageKey: MessageKey,
      MessageText: MessageText,
      Mentions: Mentions,
      MessageType: MessageType,
      PatientKey: PatientKey,
      APIKeyKey: APIKeyKey,
      SenderType: SenderType,
      SentAt: SentAt,
      Sequence: Sequence,
      TeamKey: TeamKey,
      UserKey: UserKey,
      SeenBy: SeenBy,
      SendFailed: SendFailed,
      Uploading: Uploading,
      SameSenderAsNextMessage: SameSenderAsNextMessage,
      SameSenderAsPreviousMessage: SameSenderAsPreviousMessage,
      CurrentUserKey: currentUserKey,
      Subscribers: subscribers,

      renderTextMessage: renderTextMessage,
      renderFileMessage: renderFileMessage,
      renderMetaMessage: renderMetaMessage,
      renderAutoReplyMessage: renderAutoReplyMessage,
      renderDateMarker: renderDateMarker,
      renderConversationMarker: noop,

      onDelete: onDelete,
      deleted: Deleted,
      deliveryStatus: deliveryStatus || _message.deliveryStatus.DELIVERED,
      ReplyToMessageKey: ReplyToMessageKey,
      ReplyPreview: ReplyPreview,
      onReply: rowOnReply,
      onJumpToMessage: onJumpToMessage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 261}}
    )
  )
}

exports. default = _react.memo.call(void 0, Message)
